<template>
    <div
        class="document-relevance-decision-bar"
        :class="{ 'document-relevance-decision-bar--required': !hasDecision }"
    >
        <div class="document-relevance-decision-bar__copy">
            <strong>
                {{ translate(
                    'Component(ResearchReviewProcess):document-relevance-question',
                    'Is this document relevant to the request?',
                ) }}
            </strong>
            <small
                v-if="!hasDecision"
                class="document-relevance-decision-bar__hint text-less-muted"
            >
                {{ translate(
                    'Component(ResearchReviewProcess):document-relevance-required',
                    'Choose an answer to complete the review.',
                ) }}
            </small>
        </div>

        <BFormRadioGroup
            :checked="value"
            name="document-relevance-decision"
            class="document-relevance-decision-bar__options"
            @input="$emit('input', $event)"
        >
            <BFormRadio
                value="relevant"
            >
                {{ translate('Component(Choice):yes', 'Yes') }}
            </BFormRadio>
            <BFormRadio
                value="irrelevant"
            >
                {{ translate('Component(Choice):no', 'No') }}
            </BFormRadio>
        </BFormRadioGroup>
    </div>
</template>

<script>
import { BFormRadio, BFormRadioGroup } from 'bootstrap-vue'

export default {
    name: 'DocumentRelevanceDecisionBar',
    components: { BFormRadio, BFormRadioGroup },
    props: {
        value: {
            type: String,
            default: 'uncertain',
        },
    },
    computed: {
        hasDecision() {
            return ['relevant', 'irrelevant'].includes(this.value)
        },
    },
    methods: {
        translate(key, fallback) {
            const translation = this.$t(key)

            return translation && translation !== key ? translation : fallback
        },
    },
}
</script>

<style lang="scss" scoped>
.document-relevance-decision-bar {
    position: sticky;
    bottom: 0;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
    min-height: 3.75rem;
    padding: .75rem 1rem;
    border: 1px solid #ebe9f1;
    border-radius: .357rem;
    background: #fff;
    box-shadow: 0 -.25rem .75rem rgba(34, 41, 47, .08);
}

.document-relevance-decision-bar__copy {
    min-width: 0;
}

.document-relevance-decision-bar--required {
    border-color: #ff9f43;
    background: #fff8f1;
}

.document-relevance-decision-bar__hint {
    display: block;
    margin-top: .15rem;
}

.document-relevance-decision-bar--required .document-relevance-decision-bar__hint {
    color: #9f5b00 !important;
}

.document-relevance-decision-bar__options {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    flex: 0 0 auto;

    ::v-deep .custom-control {
        margin: 0;
    }
}

@media (max-width: 575.98px) {
    .document-relevance-decision-bar {
        align-items: flex-start;
        flex-direction: column;
        gap: .5rem;
    }
}
</style>
